<template>
  <el-header class="nav-container m-header">
    <div class="navbar header-div">
      <div class="header-logo" @click="toHome()">公卫辅助及慢病健康管理系统</div>
      <div class="header-menu" id="headerMenu">
        <el-menu  class="el-menu-demo" mode="horizontal" @select="handleSelect" active-text-color="#2362FB" :default-active="onRoutes">
          <template v-for="(item, index) in menuList">
            <el-submenu v-if="item.children && item.children.length > 0" :key="index + 'el-submenu'" :index="item.name">
              <template slot="title">
                <i :class="item.menuIcon"></i>
                <span>{{ item.meta != null ? item.meta.title : ''}}</span>
              </template>
              <template v-for="(single,ium) in item.children">

                <el-submenu v-if="single.children && single.children.length > 0"  :key="ium + 'el-submenu'" :index="single.name">
                  <template slot="title">
                    <i :class="item.menuIcon"></i>
                    <span>{{ single.meta != null ? single.meta.title : '' }}</span>
                  </template>

                  <template v-for="(second,secondNum) in single.children">

                    <el-submenu v-if="second.children && second.children.length > 0"  :key="secondNum + 'el-submenu'" :index="second.name">
                      <template slot="title">
                        <i :class="second.menuIcon"></i>
                        <span>{{ second.meta != null ? second.meta.title : '' }}</span>
                      </template>

                      <el-menu-item v-if="second.children" v-for="(simple,num) in second.children" :key="num + 'el-submenu'" :index="simple.name">
                        <i :class="simple.menuIcon" />
                        <span>{{ simple.meta != null ? simple.meta.title : '' }}</span>
                      </el-menu-item>
                    </el-submenu>

                    <el-menu-item v-else :key="secondNum + second.name" :index="second.name">
                      <i :class="second.menuIcon" />
                      <span>{{ second.meta != null ? second.meta.title : '' }}</span>
                    </el-menu-item>
                  </template>

                </el-submenu>

                <el-menu-item v-else :key="ium + single.name" :index="single.name">
                  <i :class="single.menuIcon" />
                  <span>{{ single.meta != null ? single.meta.title : '' }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
<!--            <el-menu-item v-else :key="index + item.name" :index="item.name" class="test11111">-->
<!--              <i :class="item.menuIcon" />-->
<!--              <span>{{ item.meta != null ? item.meta.title : '' }}</span>-->
<!--            </el-menu-item>-->
          </template>
          <el-submenu v-if="moreArr.length > 0" class="menuItem" index="99999">
            <template slot="title">更多</template>
              <template v-for="(item, index) in moreArr">
                <el-submenu v-if="item.children && item.children.length > 0" :key="index + 'el-submenu'" :index="item.name">
                  <template slot="title">
                    <i :class="item.menuIcon"></i>
                    <span>{{ item.meta != null ? item.meta.title : ''}}</span>
                  </template>
                  <template v-for="(single,ium) in item.children">
                    <el-submenu v-if="single.children && single.children.length > 0"  :key="ium + 'el-submenu'" :index="single.name">
                      <template slot="title">
                        <i :class="item.menuIcon"></i>
                        <span>{{ single.meta != null ? single.meta.title : '' }}</span>
                      </template>

                      <template v-for="(second,secondNum) in single.children">

                        <el-submenu v-if="second.children && second.children.length > 0"  :key="secondNum + 'el-submenu'" :index="second.name">
                          <template slot="title">
                            <i :class="second.menuIcon"></i>
                            <span>{{ second.meta != null ? second.meta.title : '' }}</span>
                          </template>

                          <el-menu-item v-if="second.children" v-for="(simple,num) in second.children" :key="num + 'el-submenu'" :index="simple.name">
                            <i :class="simple.menuIcon" />
                            <span>{{ simple.meta != null ? simple.meta.title : '' }}</span>
                          </el-menu-item>
                        </el-submenu>

                        <el-menu-item v-else :key="secondNum + second.name" :index="second.name">
                          <i :class="second.menuIcon" />
                          <span>{{ second.meta != null ? second.meta.title : '' }}</span>
                        </el-menu-item>
                      </template>

                    </el-submenu>

                    <el-menu-item v-else :key="ium + single.name" :index="single.name">
                      <i :class="single.menuIcon" />
                      <span>{{ single.meta != null ? single.meta.title : '' }}</span>
                    </el-menu-item>
                  </template>
                </el-submenu>
              </template>
          </el-submenu>

        </el-menu>
      </div>
      <div class="header-right">
        <el-dropdown trigger="click" @command="moreMenuClick" id="righted">
          <div class="user-container">
            <img class="head-user-photo" :src="userInfo.headImg" v-if="!!userInfo.headImg">
            <img class="head-user-photo" src="../../../assets/img/default.png" v-if="!userInfo.headImg">
            <div class="head-user-name">{{userInfo.realname}}</div>
          </div>
          <el-dropdown-menu slot="dropdown" class="el-dropdown-unarrow">
            <el-dropdown-item
              v-for="(item, index) in moreMenu"
              :key="index"
              :command="item.command"
              :divided="item.divided"
              :icon="item.icon"
            >{{ item.label }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="flex-container">
          <el-button-group>
            <!--文档中心-->
<!--            <el-button class="omega-button" type="text"  @click="initDocument"><el-icon class="wk wk-search-white"></el-icon></el-button>-->
            <!--消息图标-->
<!--            <el-button class="omega-button iconWord" type="text" @click="initMessageDialog" v-if="isMessageButtonShow"><el-badge :value="messageNum" class="item" :max="99" :hidden="messageNum<=0"><i class="el-icon-message-solid"></i></el-badge></el-button>-->
            <!--标准文件图标-->
<!--            <el-button class="omega-button" type="text"  @click="initStdFile" v-if="isStdFileButtonShow"><el-icon class="stdFile"></el-icon></el-button>-->
            <!--特殊字符图标-->
<!--            <el-button class="omega-button" type="text" @click="initWordInfo">Ω</el-button>-->
          </el-button-group>
        </div>
      </div>
    </div>
    <!--修改密码-->
    <CheckPassWord ref="checkPassWord" v-if="checkPassWordShow"></CheckPassWord>
    <!--基本信息-->
    <header-page-base-info ref="baseInfo" v-if="baseInfoShow" @getUserInfo = getUserInfo></header-page-base-info>
    <!--资源中心-->
    <down-list ref="downList" v-if="isDownloadShow"></down-list>
    <!--字符内容-->
    <word-info ref="wordInfo" v-if="isWordInfoShow"></word-info>
    <!-- 页面布局 -->
    <page-layout-set ref="pageLayoutSet" v-if="isPageLayoutSetShow"></page-layout-set>
    <!--标准文件-->
    <std-file-view-list-dialog ref="stdFileViewList" v-if="isStdFileShow"></std-file-view-list-dialog>
    <el-drawer :with-header="false" :visible.sync="drawer" :direction="direction" :before-close="handleCloseTodoDrawer">
      <todo></todo>
    </el-drawer>
    <!--消息列表-->
    <message-list-dialog v-if="isMessageDialogShow" ref="messageListDialog" @getUnreadNum="getUnreadNum"></message-list-dialog>
    <!-- 切换主题 -->
    <switch-theme v-if="isSwitchThemeShow" ref="switchTheme"></switch-theme>
    <!-- 公司信息 -->
    <company-info v-if="isCompanyInfoShow" ref="companyInfo"></company-info>
  </el-header>
</template>

<script>
    import { mapGetters } from 'vuex'
    import CheckPassWord from '../../checkPassword'
    import HeaderPageBaseInfo from '../../HeaderPageBaseInfo'
    import WordInfo from "../../WordInfo";
    import store from '../../../store'
    import SwitchTheme from "../../header/SwitchTheme.vue";
    import CompanyInfo from "../../header/CompanyInfo.vue"
    export default {
        name: "headerPage",
        data() {
          return {
            drawer: false,
            direction: 'ltr',
            unreadNums: {
              announceCount : 1,
              allCount: 1,
            },
            selectedMenu: '',            //
            menuOptions: [],            //可选列表
            userInfo: {
              realname: '张三',
              userId:'',
              headImg:'',
            },
            menuList: [],            //常规菜单列表
            moreArr: [],             //更多的列表
            checkPassWordShow: false,
            isSwitchThemeShow: false,                   //是否显示【切换标题】
            isCompanyInfoShow: false,                   //是否显示【公司信息】
            baseInfoShow: false,
            isDownloadShow: false,        //资源中心
            isProductManualShow: false,   //产品手册
            isWordInfoShow: false,        //字符内容
            isStdFileShow: false,        //标准文件
            isStdFileButtonShow: false,        //标准文件按钮
            isPageLayoutSetShow: false,                   //是否显示【页面设置】
            isMessageButtonShow: false,                   //通知按钮
            isMessageDialogShow: false,                   //显示通知弹窗
            messageNum: 0 , //右上角消息按钮的数字显示

          };
        },
        computed: {
          ...mapGetters([
            'routesLists'
          ]),
          moreMenu() {
            return [{
              command: 'baseInfo',
              divided: false,
              label: '基本信息',
              icon: 'wk wk-user'
            },{
              command: 'checkPass',
              divided: false,
              label: '修改密码',
              icon: 'wk wk-user'
            },
            // {
            //   command: 'codeGenerate',
            //   divided: false,
            //   label: '代码生成',
            //   icon: 'wk wk-user'
            // },
            // {
            //   command: 'bi',
            //   divided: false,
            //   label: '智能分析',
            //   icon: 'wk wk-user'
            // },
            // {
            //   command: 'companyInfo',
            //   divided: false,
            //   label: '充值信息',
            //   icon: 'wk wk-user'
            // },
            // {
            //   command: 'switchTheme',
            //   divided: false,
            //   label: '切换主题',
            //   icon: 'wk wk-user'
            // },
            {
              command: 'logOut',
              divided: false,
              label: '退出登录',
              icon: 'wk wk-logout'
            }]
          },
          onRoutes() {
            // console.log('进来了~~');
            // console.log(this.$route.path.replace("/", ""));
            let list = this.$route.path.replace("/", "");


            return list;
          },
        },
         components: {
           CheckPassWord,
           HeaderPageBaseInfo,
           WordInfo,
           SwitchTheme,
           CompanyInfo
   			 },
   			created () {
          this.$nextTick(()=>{
            this.menuOptions = this.routesLists;
            this.initMenu();       //初始化菜单列表
            this.getUserInfo();    //获取用户信息
          })
		    },
        methods: {
          //去首页
          toHome(){
            window.location.href = "/";
          },
        	//获取登录信息
        	getUserInfo() {
            this.userInfo.userId = this.$store.state.user.userId
            this.userInfo.realname = this.$store.state.user.name

		        this.request({
	         		method:'post',
              url:'/web/service?method=tCoreUser_getUserInfo',
		        }).then((response) =>{
		          if (response && response.code === 0) {

		            this.userInfo.userId = response.data.user.id
		            this.userInfo.realname = response.data.user.userName
                if(!!response.data.user.photo){
                  this.userInfo.headImg = process.env.FILE_URL + '/web/getResource/' + response.data.user.photo;
                }
                // 更新右上角图标权限
                let serviceCodes = ',' + localStorage.getItem('serviceCodes') + ','
                if (serviceCodes.concat(',METAL_STDLIST,')){  //金属方法查看列表
                  this.isStdFileButtonShow = true;
                }
                if (serviceCodes.concat(',METAL_MESSAGE,')){  //金属方法查看列表
                  this.isMessageButtonShow = true;
                  // this.getUnreadNum();
                }


		          }
		        })
		      },

          handleSelect(path) {
            this.$router.push(path)
          },

          //关闭待办页面
          handleCloseTodoDrawer(done){
            done();
          },
          //打开待办的页面
          handleOpenTodoDrawer() {
            this.drawer = true;
								// this.$router.push('/report-manage');
          },
          moreMenuClick(command) {
            if (command == 'baseInfo') {  //如果是 【个人信息】
              this.baseInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.baseInfo.init(this.userInfo.userId) ;//初始化页面
              })

            } else if (command == 'logOut') {
              this.$store.dispatch('user/logout')
                .then(() => {
                  location.reload()
                })
                .catch(() => {
                  location.reload()
                })

              // this.$confirm('退出登录？', '提示', {
              //   confirmButtonText: '确定',
              //   cancelButtonText: '取消',
              //   type: 'warning'
              // }).then(() => {
              //
              // }).catch(() => {})
            }else if (command == 'checkPass'){
            	this.checkPassWordShow = true;
				          this.$nextTick(()=>{
				          this.$refs.checkPassWord.init(this.userInfo.userId) ;//初始化页面
				        })
            }else if (command == 'switchTheme'){     //切换主题
            	this.isSwitchThemeShow = true;
              this.$nextTick(()=>{
                this.$refs.switchTheme.init() ;//初始化页面
              })
            }else if (command == 'companyInfo'){     //公司信息
            	this.isCompanyInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.companyInfo.init() ;//初始化页面
              })
            }else if (command === 'download'){
              this.isDownloadShow = true;
              this.$nextTick(()=>{
                this.$refs.downList.init() ;//初始化页面
              })
            }else if (command === 'codeGenerate'){
              this.$router.push('generate')
              window.open(this.$router.resolve('generate').href, '_blank')
            }else if (command === 'bi'){
              this.$router.push('bi')
              window.open(this.$router.resolve('bi').href, '_blank')
            }else if (command === 'productManual'){
              this.$router.push('common-productManual')
              // this.isProductManualShow = true;
              // this.$nextTick(()=>{
              //   this.$refs.productManual.init() ;//初始化页面
              // })
            }else if (command === 'layoutSet'){        //页面布局
              this.isPageLayoutSetShow = true;
              this.$nextTick(()=>{
                this.$refs.pageLayoutSet.init() ;//初始化页面
              })
            }else if (command === 'wordInfo'){
              this.isWordInfoShow = true;
              this.$nextTick(()=>{
                this.$refs.wordInfo.init() ;//初始化页面
              })
            }
          },

          initWordInfo() {
            this.isWordInfoShow = true;
            this.$nextTick(()=>{
              this.$refs.wordInfo.init() ;//初始化页面
            })
          },
          // 打开文档
          initDocument() {
            this.$router.push('document-info')
          },
          // 初始化标准文件
          initStdFile() {
            this.isStdFileShow = true;
            this.$nextTick(()=>{
              this.$refs.stdFileViewList.init() ;//初始化页面
            })
          },
          //初始化菜单列表
          initMenu(){
            //判断能显示的数量  headerMenu
            let allMenuWidth = document.getElementById("headerMenu").offsetWidth;
            if(!allMenuWidth){
              allMenuWidth = 1000;
            }
            let menuNum = parseInt(allMenuWidth/100) - 2
            for (let i = 0; i < this.routesLists.length; i++) {
              let temp = this.routesLists[i];
              if(this.menuList.length < menuNum){
                this.menuList.push(temp);
              }else{
                this.moreArr.push(temp);
              }
            }
            // console.log('+++++++++++++++++++');
            // console.log(this.menuList);


            // let newArr = JSON.parse(JSON.stringify(this.data));
            // let menuitem = document.getElementsByClassName("menuItem");
            // let widthArr = [];
            // for (let i = 0; i < menuitem.length; i++) {
            //   widthArr.push(menuitem[i].clientWidth);
            // }
            // this.isBeyond(widthArr);
            // //更多的数组
            // let arr = [];
            // if (this.existing != 0) {
            //   arr = newArr.splice(this.existing, newArr.length - 1);
            // }
            // this.moreArr = arr;
          },
          isBeyond(widthArr) {
            let menu = document.getElementsByClassName("menuList");
            if (this.sum(widthArr) > menu[0].clientWidth) {
              this.isb = true;
              let newArr = this.data.slice(0, this.data.length - 1);
              let newWidthArr = widthArr.slice(0, this.data.length - 1);
              this.data = newArr;
              this.isBeyond(newWidthArr);
            } else {
              if (this.isb) {
                let newArr = this.data.slice(0, this.data.length - 1);
                let newWidthArr = widthArr.slice(0, this.data.length - 1);
                this.data = newArr;
                this.existing = newWidthArr.length;
              }
            }
          },
          sum(arr) {
            return arr.reduce(function (prev, curr, idx, arr) {
              return prev + curr;
            });
          },
          /** 转换菜单数据结构 */
          normalizer(node) {
            if (node.children && !node.children.length) {
              delete node.children;
            }
            return {
              id: node.menuId,
              label: node.menuName,
              children: node.children
            };
          },
          // 设置右上角 消息栏的数字增长
          addMessage(){
            if (this.isMessageButtonShow){
              this.messageNum ++;
            }
          },
          //初始化消息弹窗
          initMessageDialog(){
            this.isMessageDialogShow = true;
            this.$nextTick(()=>{
              this.$refs.messageListDialog.init();
            })
          },
          //获取未读消息数字
          getUnreadNum(){
            return this.request({
              method:'post',
              url:'/web/service',
              params:{
                'method':'tMetalSendMessage_findUnreadNum',
              }
            }).then((response) =>{          //这里使用了ES6的语法
              // 请求成功返回的数据
              //如果返回编码不为0，提示失败语
              if(response.code != '0'){
                this.$message.error(response.msg);
                return false;
              }
              const data = response.data;
              const num = Number(data.num);
              this.messageNum = num;
            })
          }


        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .nav-container {padding: 0;box-shadow: 0px 1px 2px #dbdbdb;z-index: 100;min-width: 1200px;font-size: 15px;}

  .header-div{height: 48px;min-height: 48px;display: flex;align-items: center;position: relative;padding: 0 30px;background: #27986d;}
  .header-div .header-logo{color: #fff;white-space: nowrap;font-size: 16px;font-style: italic;font-weight: 700;text-align: center;width: 220px;cursor: pointer;}
  .header-div .header-menu{flex: 1;display: flex;min-width: 500px;height: 100%;overflow-x: auto;line-height: 48px;font-size: 15px;}

  .header-div .header-menu .el-menu--horizontal>.el-menu-item{height: 48px;line-height: 48px;border: 0px solid #27986d;}
  .m-header {
    height: 48px !important;

  }

  // 菜单
  .el-menu {
    overflow: hidden;

    /deep/ .el-submenu__icon-arrow {
      display: none;
    }

    /deep/ .el-submenu {
      .el-submenu__title {
        i {
          color: $xr-color-success;
        }
      }
    }

    /deep/ .el-submenu.is-active {
      .el-submenu__title {
        i {
          color: $xr-color-success;
        }
      }
    }



  }


  //ul的宽度


  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup{

  }

  .el-menu-item{
    margin: 0 !important;
  }

  //li的高度
  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
    height: 30px !important;
    line-height: 30px !important;
    font-size: 12px;
    padding: 0 10px !important;
  }


  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .el-menu-item {
    padding: 0;
    margin: 0 20px;
    font-size: 16px;
    font-weight: 500;
    color: #2a304d;
    i {
      color: #5c6075;
    }
  }

  .el-menu-item:hover {
    i {
      color: $xr-color-primary;
    }
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: $xr-color-primary;
  }

  .el-menu-item.is-active {
    border-width: 3px;
    i {
      color: $xr-color-primary;
    }
  }

  // 系统消息
  .wk-announcement,
  .wk-bell {
    color: #9DA9C2;
    cursor: pointer;
    font-size: 20px;
  }

  .el-badge {
    margin-right: 20px;
  }

  .user-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
    .user-img {
      margin-right: 8px;
    }
    .mark {
      font-size: 15px;
      color: #aaaaaa;
    }
  }

  .user-container:hover {
    .mark {
      color: #2486e4;
    }
  }

  .el-menu-item {
    padding: 0;
    margin: 0 20px;
    font-size: 16px;
    font-weight: 500;
    color: #2a304d;
    i {
      color: #5c6075;
    }
  }

  .el-menu-item:hover {
    i {
      color: $xr-color-primary;
    }
  }

.el-dropdown-unarrow{
		width: 100px;
}

.head-user-photo{
  height: 30px;
  width: 30px;
  border-radius: 30px;
  margin-right: 8px;
}

.head-user-name{color: #fff; font-size: 12px;}

.header-select-main {line-height: 29px;float: left;width: 150px;height: 29px;line-height: 29px;}
.header-select-main .vue-treeselect__control {height: 29px !important;}
.header-select-main .vue-treeselect__placeholder {line-height: 29px;}
.header-select-main .vue-treeselect__single-value {line-height: 29px;}

  .flex-container {
    float: right; /* 向右浮动 */
    display: flex;
    align-items: center; /* 垂直居中 */
    margin-right: 20px;
  }

  .omega-button {
    font-size: 20px;
    background: transparent;
    color: white;
    width: 40px;
    padding-left: 10px;
    padding-right: 10px;
  }
  //#righted{
  //  float: right; /* 向右浮动 */
  //  display: flex;
  //}
  .stdFile{ /* 右上角金属标准文件图标  */
    display: inline-block;
    width: 18px;
    height: 18px;
    background-image: url('../../../assets/img/检验标准文件.png');
    background-size: 18px;
  }
  .iconWord{ // 图标字体
    font-size: 17px;
    line-height: 18px;
    vertical-align:bottom;
  }
</style>



// WEBPACK FOOTER //
// src/components/theme/default/HeaderPage.vue